<template>
  <ul class="sv-review-stars">
    <li v-for="n in starsObj.solid_star" :key="`${n}-solid`">
      <img src="https://snapsupplements.com/images/icons/star-solid-green.svg" alt="Star Icon" />
    </li>
    <li v-if="starsObj.half_star">
      <img
        src="https://snapsupplements.com/images/icons/star-half-2-green.svg"
        alt="Half Star Icon"
      />
    </li>
    <li v-for="n in starsObj.empty_star" :key="`${n}-empty`">
      <img
        src="https://snapsupplements.com/images/icons/star-empty-green.svg"
        alt="Empty Star Icon"
      />
    </li>
  </ul>
</template>


<script>
export default {
  props: {
    stars: {
      type: Object
    }
  },
  computed: {
    starsObj() {
      return this.stars.average_rating > 0
        ? this.stars
        : { ...this.stars, solid_star: 5 };
    }
  }
};
</script>


<style lang="scss">
@import "../assets/sass/_variables.scss";
.sv-review-stars {
  display: inline-flex;
  line-height: 0;
  li + li {
    margin-left: 8px;
  }
}
</style>
